import { styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import { MainButton } from 'src/components/MainButton'
import { MUIThemeColors } from 'src/mui-theme'
import { ShowDialogProps } from 'src/show-dialog'
import { getThemeColor } from 'src/utils'

interface DrawingPreviewDialogProps extends ShowDialogProps {
  url: string
  drawingNumber: string
  selected?: boolean
  onSelect?: () => void
}

const DrawingPreviewDialog: React.FC<DrawingPreviewDialogProps> = ({ pop, url, drawingNumber, selected, onSelect }) => {
  const { t } = useTranslation('position')
  const selectAction = onSelect
    ? [
        <MainButton
          key="select"
          variant="contained"
          disabled={selected}
          onClick={() => {
            onSelect()
            pop()
          }}
        >
          {selected ? t('configure-drawing-selected') : t('configure-select-this-drawing')}
        </MainButton>,
      ]
    : undefined

  return (
    <GenericDialogLayout title={drawingNumber} pop={pop} actions={selectAction}>
      <PreviewImage src={url} alt={drawingNumber} />
    </GenericDialogLayout>
  )
}

export default DrawingPreviewDialog

const PreviewImage = styled('img')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: '65vh',
  objectFit: 'contain',
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
}))
